<div class="cc">
  <div class="cc-panel">

    <div class="cc-barra">
      <div>
        <strong>Historial de cambios</strong>
        <span class="cc-hint">
          Cada modificación del documento con quién la elaboró y quién la autorizó.
          La más reciente va arriba.
        </span>
      </div>
      <button type="button" class="cc-btn-pri" (click)="abrirAlta()" *ngIf="puedeEditar && (!mostrarAlta)"
              [disabled]="editandoId !== null"
              [title]="editandoId !== null ? avisoBloqueo() : ''">
        + Registrar versión
      </button>
    </div>

    <!-- ===== Alta ===== -->
    <div class="cc-card edicion alta" *ngIf="mostrarAlta">
      <div class="cc-card-cab">
        <span class="cc-vchip azul">{{ nueva.version || '—' }}</span>
        <span class="cc-hint-mini">Nueva versión. El número se propone solo; ajústalo si hace falta.</span>
        <span class="cc-espacio"></span>
        <button type="button" class="cc-btn-ok" (click)="guardar()" [disabled]="guardando">
          {{ guardando ? 'Guardando…' : 'Registrar versión' }}
        </button>
        <button type="button" class="cc-btn-sec" (click)="cancelar()" [disabled]="guardando">
          Cancelar
        </button>
      </div>

      <div class="cc-form">
        <label class="campo">
          <span class="cc-et">Versión <b class="oblig">*</b></span>
          <input class="i" [maxlength]="lim.version.version" [(ngModel)]="nueva.version" placeholder="1.10" />
        </label>

        <label class="campo">
          <span class="cc-et">Fecha <b class="oblig">*</b></span>
          <input class="i" type="date" [(ngModel)]="nueva.fechaVersion" />
        </label>

        <label class="campo">
          <span class="cc-et">Elaboró <b class="oblig">*</b></span>
          <input class="i" [maxlength]="lim.version.elaboro" [(ngModel)]="nueva.elaboro" />
        </label>

        <label class="campo">
          <span class="cc-et">Autorizó <b class="oblig">*</b></span>
          <input class="i" [maxlength]="lim.version.autorizo" [(ngModel)]="nueva.autorizo" />
        </label>

        <label class="campo total">
          <span class="cc-et">Descripción del cambio <b class="oblig">*</b></span>
          <textarea class="i ta" rows="5" [maxlength]="lim.version.descripcion" [(ngModel)]="nueva.descripcion"
                    placeholder="Qué se modificó y por qué. Si cambiaron niveles de riesgo, indícalo aquí."></textarea>
        </label>
      </div>

      <p class="cc-nota">
        Si en esta versión cambiaron valoraciones o niveles de riesgo, dilo explícitamente en la
        descripción: es lo que un auditor busca al cruzar el historial con la matriz.
      </p>
    </div>

    <div class="cc-cargando" *ngIf="cargando">Cargando…</div>
    <div class="cc-vacio" *ngIf="!cargando && versiones.length === 0">Sin versiones registradas.</div>

    <!-- ===== Línea de tiempo ===== -->
    <!-- El scroll va en el envoltorio y la línea en el contenido: así la línea
         mide todo el alto real y se desplaza junto con las tarjetas. -->
    <div class="cc-scroll" *ngIf="!cargando && versiones.length > 0">
    <div class="cc-linea">
      <div class="cc-item" *ngFor="let v of historial">
        <span class="cc-punto" [class.vigente]="esVigente(v)"></span>

        <div class="cc-card" [class.esvigente]="esVigente(v)"
             [class.edicion]="editandoId === v.idMatrizVersion">

          <!-- ----- Lectura ----- -->
          <ng-container *ngIf="editandoId !== v.idMatrizVersion">
            <div class="cc-card-cab">
              <span class="cc-vchip" [class.azul]="esVigente(v)">{{ v.version }}</span>
              <span class="cc-pill-verde" *ngIf="esVigente(v)">Vigente</span>
              <span class="cc-fecha">{{ v.fechaVersion | date: 'dd/MM/yyyy' }}</span>
              <span class="cc-espacio"></span>
              <!-- Bloqueados mientras otra versión esté abierta o se esté
                   registrando una nueva: con dos formularios abiertos es fácil
                   guardar el equivocado. -->
              <button *ngIf="puedeEditar" type="button" class="cc-btn-sec mini" (click)="editar(v)"
                      [disabled]="bloqueado(v)"
                      [title]="bloqueado(v) ? avisoBloqueo() : ''">Editar</button>
              <button *ngIf="puedeEditar" type="button" class="cc-btn-rojo mini" (click)="eliminar(v)"
                      [disabled]="bloqueado(v)"
                      [title]="bloqueado(v) ? avisoBloqueo() : ''">Eliminar</button>
            </div>

            <div class="cc-cuerpo">
              <div class="cc-desc" #descRef [attr.data-id]="v.idMatrizVersion"
                   [class.recortada]="esLarga(v) && !estaExpandida(v)">
                <p class="cc-bloque" *ngFor="let b of bloquesDe(v)">
                  <strong class="cc-etq" *ngIf="b.etiqueta">{{ b.etiqueta }}</strong>{{ b.texto }}
                </p>
              </div>
              <button type="button" class="btn-mas" *ngIf="esLarga(v)" (click)="alternarDescripcion(v)">
                {{ estaExpandida(v) ? 'Ver menos' : 'Ver todo' }}
              </button>
            </div>

            <div class="cc-firmas">
              <span><span class="cc-et">Elaboró <b class="oblig">*</b></span>{{ v.elaboro }}</span>
              <span class="cc-sep">·</span>
              <span><span class="cc-et">Autorizó <b class="oblig">*</b></span>{{ v.autorizo }}</span>
            </div>
          </ng-container>

          <!-- ----- Edición ----- -->
          <ng-container *ngIf="editandoId === v.idMatrizVersion">
            <div class="cc-card-cab">
              <span class="cc-vchip azul">{{ enEdicion.version || '—' }}</span>
              <span class="cc-hint-mini">Editando esta versión</span>
              <span class="cc-espacio"></span>
              <button type="button" class="cc-btn-ok" (click)="guardarEdicion()" [disabled]="guardando">
                {{ guardando ? 'Guardando…' : 'Guardar' }}
              </button>
              <button type="button" class="cc-btn-sec" (click)="cancelarEdicion()" [disabled]="guardando">
                Cancelar
              </button>
            </div>

            <div class="cc-form">
              <label class="campo">
                <span class="cc-et">Versión <b class="oblig">*</b></span>
                <input class="i" [maxlength]="lim.version.version" [(ngModel)]="enEdicion.version" />
              </label>

              <label class="campo">
                <span class="cc-et">Fecha <b class="oblig">*</b></span>
                <input class="i" type="date" [(ngModel)]="enEdicion.fechaVersion" />
              </label>

              <label class="campo">
                <span class="cc-et">Elaboró <b class="oblig">*</b></span>
                <input class="i" [maxlength]="lim.version.elaboro" [(ngModel)]="enEdicion.elaboro" />
              </label>

              <label class="campo">
                <span class="cc-et">Autorizó <b class="oblig">*</b></span>
                <input class="i" [maxlength]="lim.version.autorizo" [(ngModel)]="enEdicion.autorizo" />
              </label>

              <label class="campo total">
                <span class="cc-et">Descripción del cambio <b class="oblig">*</b></span>
                <textarea class="i ta" rows="7" [maxlength]="lim.version.descripcion" [(ngModel)]="enEdicion.descripcion"></textarea>
              </label>
            </div>
          </ng-container>

        </div>
      </div>
    </div>
    </div>

  </div>
</div>

<!-- ==================== Confirmación ====================
     Propia y dentro del mismo contenedor: el confirm de la librería se dibuja
     en su nivel y quedaba DETRÁS de la ventana del historial. Se cierra solo
     con sus botones. -->
<div class="cc-conf-fondo" *ngIf="confirma">
  <div class="cc-conf" role="alertdialog" aria-modal="true">
    <div class="cc-conf-icono">!</div>
    <h3 class="cc-conf-titulo">{{ confirma.titulo }}</h3>
    <p class="cc-conf-texto">{{ confirma.texto }}</p>
    <p class="cc-conf-detalle" *ngIf="confirma.detalle">{{ confirma.detalle }}</p>
    <div class="cc-conf-botones">
      <button type="button" class="cc-conf-no" (click)="confirmarNo()">No</button>
      <button type="button" class="cc-conf-si" (click)="confirmarSi()">{{ confirma.botonSi }}</button>
    </div>
  </div>
</div>
